import { dataLayerEvent } from "features/dataLayer";
import { useTranslation } from "features/translations";
import { useContext, useEffect, useRef, useState } from "react";
import {
  Action,
  Icon,
  InputType as InputItem,
  Paragraph,
} from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { getUtmParamsFromLocalStorage } from "shared/utils/utmUtils/utmUtils";

import { FormContent } from "../Form.Provider";
import { FormSubmitStatus } from "../FormSubmitStatus";
import styles from "./FormApplication.module.scss";

export const FormApplication = ({ instanceId }) => {
  const { t } = useTranslation();
  const {
    data,
    type,
    buttonText,
    fields,
    canBeSubmitted,
    metaData: initialMetaData,
    pending,
    onHandle,
    onSubmit,
  } = useContext(FormContent);

  const [utmParams, setUtmParams] = useState({});
  const [metaData, setMetaData] = useState({
    ...initialMetaData,
  });
  const honeypotRef = useRef(null);

  const { events } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
  ]);

  const [event] = events;

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedUtmParams = getUtmParamsFromLocalStorage();

      const filteredUtmParams = Object.entries(storedUtmParams).reduce(
        (acc, [key, value]) => {
          if (value) acc[key] = value;
          return acc;
        },
        {}
      );

      setMetaData((prevMetaData) => ({
        ...prevMetaData,
        ...filteredUtmParams,
        pageUrl: `${window.location.origin}${window.location.pathname}`,
        instanceId: instanceId ?? "Instance ID not provided",
      }));

      setUtmParams(filteredUtmParams);
    }
  }, []);

  useEffect(() => {
    if (canBeSubmitted) {
      const cleanedData = Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim() : value,
        ])
      );
      // honeypot: приховане поле, яке заповнюють тільки боти
      cleanedData.website = honeypotRef.current?.value || "";

      onSubmit({ type, data: cleanedData, metaData });

      dataLayerEvent("application", {
        email: cleanedData?.email,
        phone: cleanedData?.phone,
      });
    }
  }, [canBeSubmitted, data, metaData, onSubmit, type]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onHandle();
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.application}>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="website"
              ref={honeypotRef}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              style={{ display: "none" }}
            />
            <div className={styles.form}>
              <div className={styles["input-group"]}>
                {fields.map((input) => {
                  return <InputItem key={input.id} {...input} />;
                })}

                <Action className={styles.submit} disabled={pending}>
                  <Paragraph color="brand" appearance="bold">
                    {t(buttonText)}
                  </Paragraph>
                  <span className={styles.arrow}>
                    <Icon className={styles.icon} name="arrow_right" />
                  </span>
                </Action>
              </div>
            </div>
          </form>
        </div>
      </div>
      <FormSubmitStatus eventSuccessText={event?.successText || undefined} />
    </>
  );
};
